import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=4f3c82d6&scoped=true&"
import script from "./AllNews.vue?vue&type=script&lang=js&"
export * from "./AllNews.vue?vue&type=script&lang=js&"
import style0 from "./AllNews.vue?vue&type=style&index=0&id=4f3c82d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c82d6",
  null
  
)

export default component.exports